var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canRenderChart
    ? _c("div", { ref: "chart-element", staticClass: "circle-chart-area" })
    : _c("LoadingBox")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }